import React, { Component, Suspense } from "react";
import * as router from "react-router-dom";
import { Redirect, Route, Switch } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { checkDocumentAccess, showAccessDeniedAlert, createSecureDownloadLink, getCleanFileName } from "../utils/DocumentAccessControl";
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,

} from "reactstrap";

import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";
import routes from "../navigation/routes";
import { bindActionCreators } from "redux";
import * as loginUserActions from "../redux/actions/loginUserActions";
import * as surveysActions from "../redux/actions/surveysActions";
import { connect } from "react-redux";
import * as poolActions from "../redux/actions/poolActions";
import { LoadPanel } from "devextreme-react/load-panel";
import metrics from "../common/metrics";
import * as BB from "../components/BBComponent";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";

import DefaultAside from "./DefaultAside";
import DefaultFooter from "./DefaultFooter";
import DefaultHeader from "./DefaultHeader";
import logo from "../assets/info.png";
import { post } from "axios";
import notify from "devextreme/ui/notify";
import * as loadingActions from "../redux/actions/loadingActions";
import * as mainActions from "../redux/actions/mainActions";
import ReactHtmlParser from "react-html-parser";
import { safeJwtDecode } from "../utilities/util";
import { callAPI, callApiGet } from "../components/Axios";
import { t } from "i18next";

let Subdomain = undefined;
let props = undefined;
let answers = [];
const taskIDArray = [];

class DefaultLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLogged: false,
      menus: undefined,
      getPopupMessage: [],
      getMessage: [],
      popupVisible: false,
      editRowVisible: false,
      QuestionsAll: [],
      existingAnswers: {},
      gridData: undefined,
      selectedTaskID: "",
      selectedTaskSurveyID: "",
      selectedTaskDescription: "",
      elemOfArray: 0,
      modalState: localStorage.getItem("modalVisible") || false,
      modalVisible: false,
      activeIndex: 0,
      selectedLoginUserID: undefined,
      loginUser: null,
      surveyCount: 0,
      allSurveys: [],
      currentSurveyIndex: 0,
      hubConnection: null,
      connection: null,
      data: [],
      TaskId: "",
      taskDetails: null,
      taskLoading: false,
    };

    let { t } = this.props;

    //  this.languages = {
    //    lutfenBekleyiniz:t("lutfenBekleyiniz")
    //  }


    var token = localStorage.getItem("token");
    if (token) {
      let user = safeJwtDecode(token);
      if (user) {
        this.state.loginUser = user;
        if (window.location.hash.includes("#!/TaskDetail")) {

        }
        else if (window.location.hash.includes("#!/TaskPool")) {

        }
        else if (window.location.hash != "#!/main" && !window.location.hash.includes("survey=true")) {
          window.location.href = "#!/main";
        }
        this.changeSelectionPriority =
          this.changeSelectionPriority.bind(this);
        this.answer = this.answer.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
        this.getMenus();
        this.getSurveys();

        // URL parametrelerini kontrol et - anket maili için
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('survey') === 'true') {
          const dbName = urlParams.get('DbName');
          const userId = urlParams.get('UserID');
          const surveyId = urlParams.get('SurveyID');
          
          if (dbName && userId && surveyId) {
            // Anket modal'ını açmak için kısa bir gecikme ekle
            setTimeout(() => {
              this.setState({ editRowVisible: true });
            }, 1000);
          }
        }

        metrics.defaultLayout = this;

      }
    }


  }

  //componentDidMount() {}

  getMenus() {
    if (this.state.loginUser != undefined) {
      if (
        this.state.loginUser.Menus != null &&
        this.state.loginUser.Menus.length > 0
      ) {
        let menus = JSON.parse(this.state.loginUser.Menus);
        let arr = { items: [] };

        if (menus.length > 0) {
          for (const item of menus[0].children) {
            arr.items.push(item);
          }
        }

        let ths = this;
        setTimeout(function () {
          ths.setState({ menus: arr });
        }, 50);
      } else {
        window.location.href = "#!/login";
        localStorage.clear();
        notify(
          "Oturum süreniz dolmuştur. Lütfen yeniden oturum açınız.",
          "error",
          3000
        );
      }
    } else {
      window.location.href = "#!/login";
      localStorage.clear();
      notify(
        "Oturum süreniz dolmuştur. Lütfen yeniden oturum açınız.",
        "error",
        3000
      );
    }
  }

  componentDidMount() {


    //const hubConnection = new HubConnection('https://localhost:5001/tysHub');

    // this.setState({ hubConnection }, () => {
    //   this.state.hubConnection
    //     .start()
    // });
    // this.state.hubConnection.on('ReceiveMessage', (loginUserId, message,taskID) => {

    // });

      this.props.actions.isLoading(false);
      //this.manageChatbotScript();
      props = this.props;
      
    // this.getPopupMessageData();
    //this.takeSurveyAndAnswers(this.state.elemOfArray);
    //this.refreshSession();
  }
    //componentDidUpdate(prevProps) {
    //    if (this.props.location.pathname !== prevProps.location.pathname) {
    //        this.manageChatbotScript(this.props.location.pathname);
    //    }
    //}

  // takeSurveyAndAnswers(number) {

  //    this.getSurveys(number).then(() => {
  //       //    this.setState({ gridData: this.props.ownSurvey[number] });

  //       //    if (this.state.gridData) {
  //       //       this.setState({
  //       //          selectedTaskID: this.state.gridData.TaskNumber.toString(),
  //       //          selectedTaskDescription: this.state.gridData.Description,
  //       //          selectedTaskSurveyID: this.state.gridData.ID
  //       //       })

  //       //       this.answer(this.state.gridData.ID);

  //       //       setTimeout(() => {

  //       //          if (this.checkIsDelayed(this.state.selectedTaskID)) {
  //       //             this.setState({ editRowVisible: false });

  //       //          }
  //       //          else {
  //       //             this.setState({ editRowVisible: true })
  //       //          }
  //       //       }, 2000)

  //       //    };
  //    })
  // }

  getSurveys(number) {
    if (this.state.loginUser != undefined) {
      let url = "/api/TaskSurvey/GetData";
      callAPI(
        callApiGet,
        url,
        {},
        async (res) => {
          if (res?.data) {
            if (!res || !res.data || res.data.length < 1) return;

            const result = res?.data;
            console.log("Gelen anketler:", result);
            
            // Tüm anketleri state'e kaydet
            this.setState({ 
              allSurveys: result,
              surveyCount: result.length 
            });
            
            // İlk anketi varsayılan olarak göster
            if (result.length > 0) {
              this.setState({ 
                gridData: result[0],
                selectedTaskID: result[0].TaskNumber.toString(),
                selectedTaskDescription: result[0].Description,
                selectedTaskSurveyID: result[0].ID,
                currentSurveyIndex: 0
              });
              
              // İlk anketin sorularını yükle
              this.answer(result[0].ID);
              
              // İlk anketi modal'da göster
              setTimeout(() => {
                if (this.checkIsDelayed(result[0].TaskNumber.toString())) {
                  this.setState({ editRowVisible: false });
                } else {
                  this.setState({ editRowVisible: true });
                }
              }, 2000);
            }
          }
        },
        true
      );
    }
  }

  getTaskData() {
    if (this.state.selectedTaskID) {
      this.props.actions.isLoading(true);
      this.setState({ taskLoading: true });

      let id = this.state.TaskId;

      let url = "api/TaskDetail/GetGridData?ID=" + id + "&TaskDetail=true";

      callAPI(
        callApiGet,
        url,
        {},
        async (res) => {
          if (res?.data) {
            let changeIconVisible = "none";
            let all = res?.data.TaskLog;
            let meID = this.state.loginUser ? this.state.loginUser.ID : null;
            let pool = res?.data;
            let descrtiption = [];
            let descrtiption2 = [];
            let status = false;
            let poolID = res?.data.PoolID;
            let viewerUserPool = res?.data.ViewerUserPool;
            let pools = [];

            let isMyTasks = false;

            if (res?.data.Effort === null) {
              this.setState({ effor: 0 });
            }
            else {
              this.setState({ effor: res?.data.Effort });
            }

            if (res?.data.ChangeResponsibleUserVisible === true) {
              changeIconVisible = "block";
            }

            if (res?.data.CreateUserID === meID) {
              isMyTasks = true;
            }

            this.setState({
              data: res?.data,
              taskDetails: res?.data,
              taskLoading: false
            });
          }
          this.props.actions.isLoading(false);
        },
        true
      );
    }
  }






  //  createHubConnection =async () => {
  //   const hubCn = new HubConnectionBuilder().withUrl("http://localhost:5001/tysHub").build()
  //   try {
  //   await hubCn.start();
  //   setHubConnection(hubCn)
  //   hubConnection.on("ReceiveMessage",(loginUserID, message,taskId)=>{
  //     if(loginUserID === this.state.loginUser.ID){
  //        //Send Notification 
  //     }

  //   } )}
  //   catch (e) {

  //   }
  //   }





  loading() {
    return (
      <div className="animated fadeIn pt-1 text-center center">
        {t("yukleniyor")}
      </div>
    );
  }

  // Anketler arası geçiş fonksiyonları
  nextSurvey = () => {
    if (this.state.currentSurveyIndex < this.state.surveyCount - 1) {
      const nextIndex = this.state.currentSurveyIndex + 1;
      const nextSurvey = this.state.allSurveys[nextIndex];
      
      this.setState({
        currentSurveyIndex: nextIndex,
        selectedTaskID: nextSurvey.TaskNumber.toString(),
        selectedTaskDescription: nextSurvey.Description,
        selectedTaskSurveyID: nextSurvey.ID,
        QuestionsAll: [],
        existingAnswers: {},
        answers: []
      });
      
      this.answer(nextSurvey.ID);
      this.getTaskData();
    }
  }

  prevSurvey = () => {
    if (this.state.currentSurveyIndex > 0) {
      const prevIndex = this.state.currentSurveyIndex - 1;
      const prevSurvey = this.state.allSurveys[prevIndex];
      
      this.setState({
        currentSurveyIndex: prevIndex,
        selectedTaskID: prevSurvey.TaskNumber.toString(),
        selectedTaskDescription: prevSurvey.Description,
        selectedTaskSurveyID: prevSurvey.ID,
        QuestionsAll: [],
        existingAnswers: {},
        answers: []
      });
      
      this.answer(prevSurvey.ID);
      this.getTaskData();
    }
  }

  async answer(ID) {

    if (this.state.loginUser != undefined) {
      let url = "api/TaskSurvey/TaskAnswer?ID=" + ID;
      callAPI(
        callApiGet,
        url,
        {},
        async (res) => {
          if (res?.data) {
            if (!res || !res.data || res.data.length < 1) return;

            var questions = [];
            var existingAnswers = {};



            // Mevcut cevapları al - yeni yapıya göre güncellendi
            if (res.data.Survey.TaskSurveyReply && res.data.Survey.TaskSurveyReply.length > 0) {
              for (var reply of res.data.Survey.TaskSurveyReply) {
                // Soru index'ini bul - artık her şık ayrı soru olduğu için farklı mapping gerekir
                var question = res.data.Survey.SurveyQuestion.find(q => q.ID === reply.SurveyQuestionID);
                
                if (question) {
                  if (question.QuestionType === "text") {
                    // Text tipi sorular için - doğrudan index bul
                    var questionIndex = res.data.Survey.SurveyQuestion.findIndex(q => q.ID === reply.SurveyQuestionID);
                    existingAnswers[questionIndex] = {
                      answer: null,
                      comment: reply.Comment || "",
                      type: "text"
                    };
                  } else {
                    // Choice tipi sorular için - şık bazlı index bul
                    // Bu kısım questions array'i oluşturulduktan sonra yapılacak
                    console.log("Choice cevabı bulundu:", reply);
                  }
                }
              }
            }

            for (var i = 0; i < res.data.Survey.SurveyQuestion.length; i++) {
              const question = res.data.Survey.SurveyQuestion[i];
              
              if (question.QuestionType === "text") {
                // Text tipi soru
                questions.push({
                  Question: question.Question,
                  QuestionType: "text",
                  QuestionID: question.ID,
                  Placeholder: question.Placeholder || "Lütfen cevabınızı buraya yazın...",
                  HasComment: false,
                  Answer1: "",
                  Answer2: "",
                  Answer3: "",
                  Answer4: "",
                });
              } else if (question.QuestionType === "choice") {
                // Choice tipi soru - tek soru olarak oluştur, şıkları içinde tut
                console.log(`Choice Soru ${i}: ${question.Question}, Şıklar:`, question.SurveyQuestionOption);
                
                if (question.SurveyQuestionOption && question.SurveyQuestionOption.length > 0) {
                  questions.push({
                    Question: question.Question,
                    QuestionType: "choice",
                    QuestionID: question.ID,
                    Placeholder: null,
                    HasComment: false,
                    // Şıkları doğru sırala: flex-direction: row-reverse ile hover efekti korunuyor
                    Answer1: question.SurveyQuestionOption[0]?.Option || "Çok Kötü", // 1. yıldız - en sol (Çok Kötü)
                    Answer2: question.SurveyQuestionOption[1]?.Option || "Kötü",     // 2. yıldız (Kötü)
                    Answer3: question.SurveyQuestionOption[2]?.Option || "İyi",      // 3. yıldız (İyi)
                    Answer4: question.SurveyQuestionOption[3]?.Option || "Çok İyi",  // 4. yıldız - en sağ (Çok İyi)
                    // Şık ID'lerini de tut
                    OptionID1: question.SurveyQuestionOption[0]?.ID || null,
                    OptionID2: question.SurveyQuestionOption[1]?.ID || null,
                    OptionID3: question.SurveyQuestionOption[2]?.ID || null,
                    OptionID4: question.SurveyQuestionOption[3]?.ID || null,
                    // Tüm şıkları array olarak da tut
                    Options: question.SurveyQuestionOption.map(opt => ({
                      ID: opt.ID,
                      Option: opt.Option
                    }))
                  });
                  console.log(`Oluşturulan choice soru:`, questions[questions.length - 1]);
                }
              }
            }

            // Choice cevaplarını questions array'ine göre map et
            if (res.data.Survey.TaskSurveyReply && res.data.Survey.TaskSurveyReply.length > 0) {
              for (var reply of res.data.Survey.TaskSurveyReply) {
                var question = res.data.Survey.SurveyQuestion.find(q => q.ID === reply.SurveyQuestionID);
                
                if (question && question.QuestionType === "choice") {
                  // Questions array'inde bu sorunun index'ini bul
                  const questionIndex = questions.findIndex(q => q.QuestionID === question.ID);
                  
                  if (questionIndex !== -1) {
                    // Bu sorunun hangi şığına ait olduğunu bul
                    const option = question.SurveyQuestionOption.find(opt => opt.ID === reply.SurveyQuestionOptionID);
                    if (option) {
                      // Şık index'ini bul (0-3 arası)
                      const optionIndex = question.SurveyQuestionOption.findIndex(opt => opt.ID === option.ID);
                      const selectedAnswer = question.SurveyQuestionOption[optionIndex]?.Option;
                      
                      existingAnswers[questionIndex] = {
                        answer: selectedAnswer,
                        comment: reply.Comment || "",
                        type: "choice",
                        selectedOptionID: reply.SurveyQuestionOptionID
                      };
                    }
                  }
                }
              }
            }

            // Mevcut cevapları answers dizisine yükle
            answers = [];
            Object.keys(existingAnswers).forEach(questionIndex => {
              const existing = existingAnswers[questionIndex];
              const question = questions[questionIndex];
              
              if (existing.type === "text") {
                // Text tipi sorular için
                answers.push({
                  q: parseInt(questionIndex),
                  a: null,
                  surveyQuestionId: question.QuestionID,
                  surveyQuestionOptionId: null,
                  reply: "text",
                  comment: existing.comment,
                  type: existing.type
                });
              } else {
                // Choice tipi sorular için
                answers.push({
                  q: parseInt(questionIndex),
                  a: existing.answer,
                  surveyQuestionId: question.QuestionID,
                  surveyQuestionOptionId: existing.selectedOptionID, // Doğru şık ID'si
                  reply: existing.answer,
                  comment: existing.comment,
                  type: existing.type
                });
              }
            });

            this.setState({
              QuestionsAll: questions,
              existingAnswers: existingAnswers
            });

            this.setState({ TaskId: res.data.TaskID });
            this.getTaskData();

          }
        },
        true
      );
    }


    // BB.FetchJSON("api/TaskSurvey/TaskAnswer?ID=" + ID).then((data) => {


    //   var questions = [];

    //   for (var i = 0; i < data.Survey.SurveyQuestion.length; i++) {
    //     /*  answers.push({
    //             q: i,
    //             a: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option
    //          }); */
    //     questions.push({
    //       Question: data.Survey.SurveyQuestion[i].Question,
    //       Answer1: data.Survey.SurveyQuestion[i].SurveyQuestionOption[0].Option,
    //       Answer2: data.Survey.SurveyQuestion[i].SurveyQuestionOption[1].Option,
    //       Answer3: data.Survey.SurveyQuestion[i].SurveyQuestionOption[2].Option,
    //       Answer4: data.Survey.SurveyQuestion[i].SurveyQuestionOption[3].Option,
    //     });
    //   }
    //   this.setState({ QuestionsAll: questions });
    // });
  }

  // Choice sorular için yıldız rating sistemi
  changeSelectionPriority(e) {
    const q = e.target.name.split('-')[0];
    const a = e.target.value;
    const question = this.state.QuestionsAll[q];

    // Seçilen şığın ID'sini bul
    let selectedOptionID = null;
    if (a === question.Answer1) selectedOptionID = question.OptionID1;
    else if (a === question.Answer2) selectedOptionID = question.OptionID2;
    else if (a === question.Answer3) selectedOptionID = question.OptionID3;
    else if (a === question.Answer4) selectedOptionID = question.OptionID4;

    // Mevcut cevabı answers array'inden çıkar
    answers = answers.filter(item => item.q !== parseInt(q) || item.type !== "choice");

    // Yeni choice cevabı ekle
    answers.push({
      q: parseInt(q),
      a: a,
      surveyQuestionId: question.QuestionID,
      surveyQuestionOptionId: selectedOptionID, // Doğru şık ID'si
      reply: a,
      comment: null,
      type: "choice"
    });

    // State'i güncelle
    const updatedExistingAnswers = { ...this.state.existingAnswers };
    updatedExistingAnswers[q] = { 
      answer: a, 
      comment: "", 
      type: "choice",
      selectedOptionID: selectedOptionID
    };
    this.setState({ existingAnswers: updatedExistingAnswers });
  }



  handleTextChange = (e) => {
    const q = e.target.id.split('-')[0];
    const text = e.target.value;

    // Mevcut cevabı bul ve sadece comment kısmını güncelle
    const existingAnswer = answers.find(item => item.q == q);
    const question = this.state.QuestionsAll[q];
    
    if (existingAnswer) {
      existingAnswer.comment = text;
      
      // Text tipi sorular için reply'ı "text" olarak ayarla
      if (question.QuestionType === "text") {
        existingAnswer.reply = "text";
        existingAnswer.a = null;
        existingAnswer.surveyQuestionOptionId = null;
        existingAnswer.type = "text";
      }
    } else {
      // Text tipi sorular için yeni cevap oluştur (boş olsa bile)
      if (question.QuestionType === "text") {
        answers.push({
          q: parseInt(q),
          a: null,
          surveyQuestionId: question.QuestionID,
          surveyQuestionOptionId: null,
          reply: "text",
          comment: text || "", // Boş string olarak kaydet
          type: "text"
        });
      }
    }

    // state'i güncelle - comment kısmını güncelle
    const updatedExistingAnswers = { ...this.state.existingAnswers };
    if (!updatedExistingAnswers[q]) {
      updatedExistingAnswers[q] = { 
        answer: question.QuestionType === "text" ? null : null, 
        comment: text || "", 
        type: question.QuestionType || "choice" 
      };
    } else {
      updatedExistingAnswers[q].comment = text || "";
      if (question.QuestionType === "text") {
        updatedExistingAnswers[q].type = "text";
        updatedExistingAnswers[q].answer = null;
      }
    }

    this.setState({ existingAnswers: updatedExistingAnswers });
  }

  answerSave() {
    const formData = new FormData();
    let questionsAll = this.state.QuestionsAll;

    // Sadece choice tipi sorular için validation
    for (let i = 0; i < questionsAll.length; i++) {
      const question = questionsAll[i];
      
      if (question.QuestionType === "choice") {
        // Choice tipi sorular için yıldız puanı kontrol et
        const questionAnswer = answers.find(a => a.q === i && a.type === "choice");
        
        if (!questionAnswer || !questionAnswer.a) {
          notify(`"${question.Question}" sorusu için lütfen yıldız puanı veriniz.`, "warning", 4000);
          return;
        }
      }
      // Text tipi sorular için hiç validation yapmıyoruz - opsiyonel
    }

    formData.append("jsonText", JSON.stringify(answers));
    formData.append("TaskSurveyID", this.state.selectedTaskSurveyID);
    formData.append("TaskID", this.state.selectedTaskID);

    if (answers.length == 0) {
      notify("Anket cevapları boş geçilemez!", "warning", 4000);
      return;
    }
    
    this.props.actions.isLoading(true);

    post("api/TaskSurvey/TaskAnswer", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    }).then((res) => {

      if (res.data.MessageStatus === true) {
        this.setState({
          editRowVisible: false,
        });
        this.props.actions.isLoading(false);
        notify("Anket Tamamlandı!", "success", 1000);
        answers = [];
      } else {
        this.setState({
          editRowVisible: false,
        });
        notify("Anket Oluşturma Hata! : " + res.data.Message, "error", 1000);
        this.props.actions.isLoading(false);
      }
    });
  }



  async saveToLocalStorage(id) {
    taskIDArray.push(id);
    localStorage.setItem("SurveyTaskID", JSON.stringify(taskIDArray));
    await this.setState({
      editRowVisible: false,
      elemOfArray: this.state.elemOfArray + 1,
    });
  }

  checkIsDelayed(id) {
    const taskId = JSON.parse(localStorage.getItem("SurveyTaskID")) || [];
    if (taskId.includes(id)) {
      return true;
    } else {
      return false;
    }
  }
    //manageChatbotScript = (path) => {
    //    const existingScript = document.getElementById("chatbot-script");
    //    const token = localStorage.getItem("token");
    //    let user = null;

    //    if (token) {
    //        try {
    //            user = jwt_decode(token);
    //        } catch (e) {
    //            console.error("Token decode hatası:", e);
    //        }
    //    }

    //    let hasTurkuazDestekPool = false;
    //    try {
    //        const pools = user?.Pools ? JSON.parse(user.Pools) : [];
    //        hasTurkuazDestekPool = pools.some(
    //            (p) => p.toUpperCase() === "3C2734D7-F00C-E911-80F7-005056B839BB"
    //        );
    //    } catch (err) {
    //        console.error("Pools parse hatası:", err);
    //    }

    //    if (hasTurkuazDestekPool) {
    //        if (!existingScript) {
    //            const script = document.createElement("script");
    //            script.id = "chatbot-script";
    //            script.src = "http://10.200.86.184:8080/static/bb-chatbot-widget.js";
    //            script.async = true;
    //            document.body.appendChild(script);

    //            script.onload = () => {
    //                if (window.initBBChatbotWidget) {
    //                    window.initBBChatbotWidget({
    //                        apiUrl: "http://10.200.86.184:8080",
    //                    });
    //                }
    //            };
    //        }
    //    } else {
    //        if (existingScript) existingScript.remove();
    //        const possibleIds = [
    //            "bb-chatbot-widget",
    //            "bb-chatbot-root",
    //            "bb-chatbot-container",
    //        ];
    //        possibleIds.forEach(id => {
    //            const el = document.getElementById(id);
    //            if (el) el.remove();
    //        });
    //        if (window.initBBChatbotWidget) {
    //            delete window.initBBChatbotWidget;
    //        }
    //    }
    //};

  handleModalVisible = () => {
    localStorage.setItem("modalVisible", true);
    this.setState({ modalVisible: false });
  };

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({ activeIndex: newIndex });
  }
  render() {
    metrics.redirectURL =
      this.props.location.pathname + this.props.location.search;
    let isLoading = this.props.loading.isLoading;
    let { t } = this.props;

    if (
      localStorage.getItem("token") === undefined ||
      localStorage.getItem("token") === "" ||
      localStorage.getItem("token") === null
    ) {
      return <Redirect push to="/login" />;
    } //Login User Dolu
    else {
      return (

        <div className="app">

          <LoadPanel
            message={t("lutfenBekleyiniz")}
            position={"center"}
            shadingColor="rgba(0,0,0,0.4)"
            visible={isLoading}
            showIndicator={true}
            shading={true}
            closeOnOutsideClick={false}
          />
          <AppHeader fixed>
            <Suspense fallback={this.loading()}>
              <DefaultHeader {...this.props} onLogout={(e) => signOut()} />
            </Suspense>
          </AppHeader>
          <div className="app-body">
            <AppSidebar display="lg" fixed minimized>
              {/*<AppSidebar display="lg" fixed minimized>*/}
              <AppSidebarHeader />
              <AppSidebarForm />
              <Suspense fallback={this.loading()}>
                <AppSidebarNav
                  navConfig={this.state.menus}
                  {...this.props}
                  router={router}
                />
              </Suspense>
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
            <main className="main" style={{ paddingTop: 15 }}>
              <Container fluid>
                <Suspense fallback={this.loading()}>
                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={(props) => <route.component {...props} />}
                        />
                      ) : null;
                    })}
                    {/* <Redirect from="/" to="/login" /> */}
                  </Switch>
                </Suspense>
              </Container>
            </main>
            <AppAside fixed>
              <Suspense fallback={this.loading()}>
                <DefaultAside {...this.props} />
              </Suspense>
            </AppAside>
          </div>
          <AppFooter>
            <Suspense fallback={this.loading()}>
              <DefaultFooter />
            </Suspense>
          </AppFooter>

          <Modal isOpen={this.state.editRowVisible} centered={true} size="sm" style={{ maxWidth: "80vw", width: "80vw" }}>
            <ModalHeader style={{ backgroundColor: "#7CAED8", color: "white", borderBottom: "2px solid #5a9bc4" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                <div>
                  <strong style={{ fontSize: "1.2em", color: "white" }}>Talep No: {this.state.selectedTaskID}</strong> - {t("numaralitalepAnketi")}
                </div>
                {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <span style={{ color: "white", fontSize: "0.9em" }}>
                    {this.state.currentSurveyIndex + 1} / {this.state.surveyCount}
                  </span>
                  <Button
                    size="sm"
                    color="light"
                    onClick={this.prevSurvey}
                    disabled={this.state.currentSurveyIndex === 0}
                    style={{ marginRight: "5px" }}
                  >
                    ← Önceki
                  </Button>
                  <Button
                    size="sm"
                    color="light"
                    onClick={this.nextSurvey}
                    disabled={this.state.currentSurveyIndex === this.state.surveyCount - 1}
                  >
                    Sonraki →
                  </Button>
                </div> */}
              </div>
            </ModalHeader>
            <ModalBody style={{ padding: "0.75rem", backgroundColor: "#fff9f5" }}>
              {this.state.taskLoading ? (
                <div className="text-center">{t("yukleniyor")}</div>
              ) : (
                <div className="row" style={{ minHeight: "400px" }}>
                  {/* Özet Bilgi - Sol Taraf */}
                  <div className="col-12 col-lg-3 mb-4" style={{ display: "flex" }}>
                    <div className="card pb-0 w-100" style={{ backgroundColor: "#fff", border: "1px solid #e3e6f0", borderRadius: "0.35rem", minHeight: "250px", maxHeight: "280px" }}>
                      <div className="card-body" style={{ padding: "1rem 0.75rem 0.5rem 0.75rem" }}>
                        <div className="mb-3 pb-2" style={{ borderBottom: "1px solid #e3e6f0" }}>
                          <h6 className="mb-1" style={{ color: "#5a5c69", fontWeight: "700" }}>{t("ozet")}</h6>
                          <small className="text-muted">{t("talebinOzetBilgisi")}</small>
                        </div>

                        {this.state.taskDetails ? (
                          <div>
                            {/* Talep No */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("talepno")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{this.state.taskDetails.TaskNumber}</span>
                              </div>
                            </div>

                            {/* Açılış */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("açılış")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                  {(() => {
                                    try {
                                      return new Date(this.state.taskDetails.CreateDate).toLocaleDateString() + " " +
                                        new Date(this.state.taskDetails.CreateDate).toLocaleTimeString();
                                    } catch (e) {
                                      return "-";
                                    }
                                  })()}
                                </span>
                              </div>
                            </div>

                            {/* Sahibi */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("sahibi")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                  {this.state.taskDetails.CreateUser ?
                                    (this.state.taskDetails.CreateUser.Name && this.state.taskDetails.CreateUser.SurName ?
                                      this.state.taskDetails.CreateUser.Name + " " + this.state.taskDetails.CreateUser.SurName :
                                      (this.state.taskDetails.CreateUser.Name || "Talep Sahibi")) +
                                    (this.state.taskDetails.RequesterEmail ? ` (${this.state.taskDetails.RequesterEmail})` :
                                      this.state.taskDetails.CreateUser.Email ? ` (${this.state.taskDetails.CreateUser.Email})` : "") : "-"}
                                </span>
                              </div>
                            </div>

                            {/* Kurum */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("kurum")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                  {this.state.taskDetails.CreateUser && this.state.taskDetails.CreateUser.CompanyName ?
                                    this.state.taskDetails.CreateUser.CompanyName : "-"}
                                </span>
                              </div>
                            </div>

                            {/* İletişim Numarası */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("gsm")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                  {this.state.taskDetails.CreateUser ?
                                    (this.state.taskDetails.CreateUser.MobilPhone === null ?
                                      (this.state.taskDetails.CreateUser.Phone || "-") :
                                      this.state.taskDetails.CreateUser.Phone === null ?
                                        this.state.taskDetails.CreateUser.MobilPhone :
                                        this.state.taskDetails.CreateUser.MobilPhone + " / " + this.state.taskDetails.CreateUser.Phone) : "-"}
                                </span>
                              </div>
                            </div>

                            {/* Talep kategorisi */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("talepkategorisi")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                  {this.state.taskDetails.CategoryTree || "-"}
                                </span>
                              </div>
                            </div>

                            {/* Talep Sorumlusu */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("talepsorumlusu")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                  {this.state.taskDetails.ResponsibleUser ?
                                    (this.state.taskDetails.ResponsibleUser.Name && this.state.taskDetails.ResponsibleUser.SurName ?
                                      this.state.taskDetails.ResponsibleUser.Name + " " + this.state.taskDetails.ResponsibleUser.SurName :
                                      (this.state.taskDetails.ResponsibleUser.Name || "Talep Sorumlusu")) : "-"}
                                </span>
                              </div>
                            </div>


                            {/* 1.Onay */}
                            {this.state.taskDetails.TaskConfirmation && this.state.taskDetails.TaskConfirmation.length > 0 && (
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>1.{t("Onay")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>
                                    {this.state.taskDetails.TaskConfirmation[0].User.Name} {this.state.taskDetails.TaskConfirmation[0].User.SurName}
                                    {this.state.taskDetails.TaskConfirmation[0].ProcurationUserID !== null
                                      ? " VEK. " + this.state.taskDetails.TaskConfirmation[0].ProcurationUser.Name + " " + this.state.taskDetails.TaskConfirmation[0].ProcurationUser.SurName
                                      : ""}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div>
                            {/* Talep No */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("talepno")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{this.state.selectedTaskID}</span>
                              </div>
                            </div>

                            {/* Açılış */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>{t("açılış")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}>-</span>
                              </div>
                            </div>

                            {/* Sahibi */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem" }}>{t("sahibi")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem" }}>-</span>
                              </div>
                            </div>

                            {/* Kurum */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem" }}>{t("kurum")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem" }}>-</span>
                              </div>
                            </div>

                            {/* İletişim Numarası */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem" }}>{t("gsm")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem" }}>-</span>
                              </div>
                            </div>

                            {/* Talep kategorisi */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem" }}>{t("talepkategorisi")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem" }}>-</span>
                              </div>
                            </div>

                            {/* Talep Sorumlusu */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem" }}>{t("talepsorumlusu")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem" }}>-</span>
                              </div>
                            </div>

                            {/* 1.Onay */}
                            <div className="row mb-2">
                              <div className="col-4">
                                <strong style={{ fontSize: "0.875rem" }}>1.{t("Onay")}</strong>
                              </div>
                              <div className="col-1">:</div>
                              <div className="col-6">
                                <span style={{ fontSize: "0.875rem" }}>-</span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Ek Bilgi - Orta */}
                  <div className="col-12 col-lg-5 mb-4" style={{ display: "flex" }}>
                    <div className="card pb-0 w-100" style={{ backgroundColor: "#fff", border: "1px solid #e3e6f0", borderRadius: "0.35rem", minHeight: "400px", display: "flex", flexDirection: "column" }}>
                      <div className="card-body" style={{ padding: "1.5rem", flex: "1" }}>
                        <div className="mb-3 pb-2" style={{ borderBottom: "1px solid #e3e6f0" }}>
                          <h6 className="mb-1" style={{ color: "#5a5c69", fontWeight: "700" }}>{t("ekbilgi")}</h6>
                          <small className="text-muted">{t("Talebeaittemelbilgilerburadayeralmaktadır")}</small>
                        </div>

                        {this.state.taskDetails ? (
                          <div>
                            {/* Talep Açıklaması */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("talepAciklamasi")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <div style={{ fontSize: "0.875rem" }}>
                                    {this.state.taskDetails.HTMLDescription ?
                                      ReactHtmlParser(this.state.taskDetails.HTMLDescription) :
                                      (this.state.taskDetails.Description ? this.state.taskDetails.Description : "-")}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Aciliyet */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("aciliyet")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>
                                    {typeof this.state.taskDetails.DegreeOfUrgency !== 'undefined' ?
                                      (this.state.taskDetails.DegreeOfUrgency === 0
                                        ? t("düşük")
                                        : this.state.taskDetails.DegreeOfUrgency === 1
                                          ? t("orta")
                                          : t("yüksek")) : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Aciliyet açıklaması */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("aciliyetaçıklaması")}*</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>
                                    {this.state.taskDetails.UrgencyDescription || "-"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Talep belgeleri */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("talepbelgeleri")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <div style={{ fontSize: "0.875rem" }}>
                                    {this.state.taskDetails.TaskDocument && this.state.taskDetails.TaskDocument.length > 0 ?
                                      this.state.taskDetails.TaskDocument
                                        .filter(item => item.Document.DocumentType === "1")
                                        .map((item, i) => {
                                          // FilePath null kontrolü - erişim süresi geçmişse null olabilir
                                          if (item.Document.FilePath) {
                                            const fileName = item.Document.FilePath.toString().split("/").pop().split("_").pop();
                                            return (
                                              <a
                                                key={i}
                                                style={{ marginRight: "10px", display: "block" }}
                                                href={item.Document.FilePath}
                                                download={fileName}
                                              >
                                                {fileName}
                                              </a>
                                            );
                                          } else {
                                            return (
                                              <span
                                                key={i}
                                                style={{ marginRight: "10px", display: "block", color: '#6c757d', cursor: 'pointer' }}
                                                onClick={() => {
                                                  Swal.fire({
                                                    title: 'Erişim Kısıtlı',
                                                    text: 'Bu dosyaya erişim süresi geçmiştir. Adminle İletişime Geçiniz.',
                                                    icon: 'warning',
                                                    confirmButtonText: 'Tamam'
                                                  });
                                                }}
                                              >
                                                Erişim süresi geçmiştir
                                              </span>
                                            );
                                          }
                                        }) : "-"
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Kapanış belgeleri */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("kapanışbelgeleri")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <div style={{ fontSize: "0.875rem" }}>
                                    {this.state.taskDetails.TaskDocument && this.state.taskDetails.TaskDocument.length > 0 ?
                                      this.state.taskDetails.TaskDocument
                                        .filter(item => item.Document.DocumentType === "3")
                                        .map((item, i) => {
                                          const fileName = getCleanFileName(item.Document.FilePath);
                                          return createSecureDownloadLink(
                                            item.Document,
                                            fileName,
                                            {
                                              key: i,
                                              style: { marginRight: "10px", display: "block" }
                                            },
                                            fileName
                                          );
                                        }) : "-"
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Kapanış Mesajı */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("kapanışmesajı")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>
                                    {this.state.taskDetails.TerminationDescription || "-"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Eklenen Açıklamalar */}
                            <div style={{ paddingBottom: "0.5rem" }}>
                              <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                                <strong style={{ fontSize: "0.875rem", color: "#5a5c69", fontWeight: "700" }}>{t("aciklamalar")}</strong>
                              </div>

                              {this.state.taskDetails && this.state.taskDetails.TaskLog ?
                                this.state.taskDetails.TaskLog
                                  .filter(log => log.LogType === 1)
                                  .sort((a, b) => new Date(b.CreateDate) - new Date(a.CreateDate))
                                  .length > 0 ? (
                                  <div style={{ maxHeight: "250px", overflowY: "auto", border: "1px solid #e9ecef", borderRadius: "0.25rem" }}>
                                    <table style={{ width: "100%", fontSize: "0.75rem", margin: "0" }}>
                                      <thead style={{ backgroundColor: "#f8f9fa", borderBottom: "1px solid #e9ecef" }}>
                                        <tr>
                                          <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "600", color: "#495057", fontSize: "0.7rem" }}>Tarih</th>
                                          <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "600", color: "#495057", fontSize: "0.7rem" }}>Kullanıcı</th>
                                          <th style={{ padding: "0.5rem", textAlign: "left", fontWeight: "600", color: "#495057", fontSize: "0.7rem" }}>Açıklama</th>
                                          <th style={{ padding: "0.5rem", textAlign: "center", fontWeight: "600", color: "#495057", fontSize: "0.7rem" }}>Dosya</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.taskDetails.TaskLog
                                          .filter(log => log.LogType === 1)
                                          .sort((a, b) => new Date(b.CreateDate) - new Date(a.CreateDate))
                                          .map((log, i) => (
                                            <tr key={i} style={{ borderBottom: "1px solid #f1f3f4" }}>
                                              <td style={{ padding: "0.4rem", verticalAlign: "top", fontSize: "0.7rem", color: "#6c757d" }}>
                                                {(() => {
                                                  try {
                                                    return new Date(log.CreateDate).toLocaleDateString("tr-TR") + "\n" +
                                                      new Date(log.CreateDate).toLocaleTimeString("tr-TR", { hour: '2-digit', minute: '2-digit' });
                                                  } catch (e) {
                                                    return "-";
                                                  }
                                                })()}
                                              </td>
                                              <td style={{ padding: "0.4rem", verticalAlign: "top", fontSize: "0.7rem", fontWeight: "500", color: "#495057" }}>
                                                {log.CreateUser ? `${log.CreateUser.Name} ${log.CreateUser.SurName}` : "Bilinmeyen"}
                                              </td>
                                              <td style={{ padding: "0.4rem", verticalAlign: "top", fontSize: "0.7rem", color: "#6c757d", maxWidth: "200px", wordWrap: "break-word" }}>
                                                {log.Description ?
                                                  (log.Description.length > 80 ?
                                                    log.Description.substring(0, 80) + "..." :
                                                    log.Description) :
                                                  "Açıklama yok"}
                                              </td>
                                              <td style={{ padding: "0.4rem", textAlign: "center", verticalAlign: "top" }}>
                                                {log.TaskLogDocument && log.TaskLogDocument.length > 0 ? (
                                                  <div>
                                                    {log.TaskLogDocument
                                                      .filter(doc => doc.Document.DocumentType === "2")
                                                      .map((docItem, docIndex) => {
                                                        // FilePath null kontrolü - erişim süresi geçmişse null olabilir
                                                        if (docItem.Document.FilePath) {
                                                          const fileName = docItem.Document.FilePath.toString().split("/").pop().split("_").pop();
                                                          return (
                                                            <a
                                                              key={docIndex}
                                                              href={docItem.Document.FilePath}
                                                              download={fileName}
                                                              style={{
                                                                display: "block",
                                                                color: "#007bff",
                                                                textDecoration: "none",
                                                                fontSize: "0.7rem",
                                                                marginBottom: "0.2rem"
                                                              }}
                                                              title={fileName}
                                                            >
                                                              {fileName}
                                                            </a>
                                                          );
                                                        } else {
                                                          return (
                                                            <span
                                                              key={docIndex}
                                                              style={{
                                                                display: "block",
                                                                color: "#6c757d",
                                                                fontSize: "0.7rem",
                                                                marginBottom: "0.2rem",
                                                                cursor: "pointer"
                                                              }}
                                                              onClick={() => {
                                                                Swal.fire({
                                                                  title: 'Erişim Kısıtlı',
                                                                  text: 'Bu dosyaya erişim süresi geçmiştir. Adminle İletişime Geçiniz.',
                                                                  icon: 'warning',
                                                                  confirmButtonText: 'Tamam'
                                                                });
                                                              }}
                                                              title="Erişim süresi geçmiştir"
                                                            >
                                                              Erişim süresi geçmiştir
                                                            </span>
                                                          );
                                                        }
                                                      })}
                                                  </div>
                                                ) : (
                                                  <span style={{ color: "#adb5bd", fontSize: "0.7rem" }}>-</span>
                                                )}
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <div style={{ padding: "1rem", textAlign: "center", color: "#6c757d", fontStyle: "italic", backgroundColor: "#f8f9fa", borderRadius: "0.25rem", border: "1px solid #e9ecef" }}>
                                    Henüz açıklama eklenmemiş
                                  </div>
                                ) : (
                                  <div style={{ padding: "1rem", textAlign: "center", color: "#6c757d", fontStyle: "italic", backgroundColor: "#f8f9fa", borderRadius: "0.25rem", border: "1px solid #e9ecef" }}>
                                    Henüz açıklama eklenmemiş
                                  </div>
                                )}
                            </div>
                          </div>
                        ) : (
                          <div>
                            {/* Talep Açıklaması */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("talepAciklamasi")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <div style={{ fontSize: "0.875rem" }}>
                                    {this.state.selectedTaskDescription ?
                                      ReactHtmlParser(this.state.selectedTaskDescription) :
                                      "-"}
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Aciliyet */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("aciliyet")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>-</span>
                                </div>
                              </div>
                            </div>

                            {/* Aciliyet açıklaması */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("aciliyetaçıklaması")}*</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>-</span>
                                </div>
                              </div>
                            </div>

                            {/* Talep belgeleri */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("talepbelgeleri")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>-</span>
                                </div>
                              </div>
                            </div>

                            {/* Kapanış belgeleri */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("kapanışbelgeleri")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>-</span>
                                </div>
                              </div>
                            </div>

                            {/* Kapanış Mesajı */}
                            <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                              <div className="row mb-2">
                                <div className="col-4">
                                  <strong style={{ fontSize: "0.875rem" }}>{t("kapanışmesajı")}</strong>
                                </div>
                                <div className="col-1">:</div>
                                <div className="col-6">
                                  <span style={{ fontSize: "0.875rem" }}>-</span>
                                </div>
                              </div>
                            </div>

                            {/* Eklenen Açıklamalar */}
                            <div style={{ paddingBottom: "0.5rem" }}>
                              <div style={{ borderBottom: "1px solid #e9ecef", marginBottom: "0.75rem", paddingBottom: "0.5rem" }}>
                                <strong style={{ fontSize: "0.875rem", color: "#5a5c69", fontWeight: "700" }}>{t("eklenenAciklamalar")}</strong>
                              </div>

                              <div style={{ padding: "1rem", textAlign: "center", color: "#6c757d", fontStyle: "italic", backgroundColor: "#f8f9fa", borderRadius: "0.25rem", border: "1px solid #e9ecef" }}>
                                Henüz açıklama eklenmemiş
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Anket Yapısı - Sağ Taraf */}
                  <div className="col-12 col-lg-4" style={{ display: "flex" }}>
                    <div className="card pb-0 w-100" style={{ backgroundColor: "#fff", border: "1px solid #e3e6f0", borderRadius: "0.35rem", minHeight: "500px", maxHeight: "500px", display: "flex", flexDirection: "column" }}>
                      <div className="card-body" style={{ display: "flex", flexDirection: "column", flex: "1", padding: "1rem", height: "100%" }}>
                        <div className="mb-3 pb-2" style={{ borderBottom: "1px solid #e3e6f0", flexShrink: "0" }}>
                          <h6 className="mb-1" style={{ color: "#5a5c69", fontWeight: "700" }}>{"Anket Soruları"}</h6>
                          <small className="text-muted">{"Lütfen tüm soruları cevaplayınız"}</small>
                        </div>

                        <div style={{
                          flex: "1",
                          overflow: "hidden",
                          paddingRight: "8px",
                          minHeight: "0",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between"
                        }}>
                          {this.state.QuestionsAll.map((item, index) => {
                            console.log(`Soru ${index}: QuestionType = ${item.QuestionType}, Question = ${item.Question}`);
                            return (
                              <div key={index} style={{
                                padding: "0.4rem",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "0.25rem",
                                border: "1px solid #e9ecef",
                                flex: "1",
                                minHeight: "60px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between"
                              }}>
                                <div style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  marginBottom: "0.25rem",
                                  gap: "0.5rem"
                                }}>
                                  <span style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    borderRadius: "50%",
                                    fontSize: "0.75rem",
                                    fontWeight: "bold",
                                    flexShrink: "0",
                                    marginTop: "0.1rem"
                                  }}>
                                    {index + 1}
                                  </span>
                                  <span style={{
                                    fontSize: "0.875rem",
                                    fontWeight: "700",
                                    lineHeight: "1.4",
                                    flex: "1",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    hyphens: "auto"
                                  }}>
                                    {item.Question}
                                  </span>
                                </div>

                                {item.QuestionType === "choice" ? (
                                  <div className="rating d-flex justify-content-end mt-2">
                                    <input
                                      type="radio"
                                      id={`${index}-star1`}
                                      name={`${index}-rating`}
                                      value={item.Answer1}
                                      onClick={this.changeSelectionPriority}
                                    />
                                    <label className="star" htmlFor={`${index}-star1`} title={item.Answer1}></label>

                                    <input
                                      type="radio"
                                      id={`${index}-star2`}
                                      name={`${index}-rating`}
                                      value={item.Answer2}
                                      onClick={this.changeSelectionPriority}
                                    />
                                    <label className="star" htmlFor={`${index}-star2`} title={item.Answer2}></label>

                                    <input
                                      type="radio"
                                      id={`${index}-star3`}
                                      name={`${index}-rating`}
                                      value={item.Answer3}
                                      onClick={this.changeSelectionPriority}
                                    />
                                    <label className="star" htmlFor={`${index}-star3`} title={item.Answer3}></label>

                                    <input
                                      type="radio"
                                      id={`${index}-star4`}
                                      name={`${index}-rating`}
                                      value={item.Answer4}
                                      onClick={this.changeSelectionPriority}
                                    />
                                    <label className="star" htmlFor={`${index}-star4`} title={item.Answer4}></label>
                                  </div>
                                ) : item.QuestionType === "text" ? (
                                  // Text tipi sorular - serbest metin alanı
                                  <div>
                                    <textarea
                                      id={`${index}-comment`}
                                      className="form-control"
                                      rows="4"
                                      placeholder={item.Placeholder || t("İsteğe bağlı olarak yorumunuzu yazabilirsiniz...")}
                                      value={this.state.existingAnswers[index] && this.state.existingAnswers[index].comment ? this.state.existingAnswers[index].comment : ""}
                                      onChange={this.handleTextChange}
                                      style={{
                                        fontSize: "0.875rem",
                                        border: "1px solid #e9ecef",
                                        borderRadius: "0.25rem",
                                        resize: "none",
                                        backgroundColor: "#f8f9fa",
                                      }}
                                    ></textarea>
                                  </div>
                                ) : null}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </ModalBody>
            <ModalFooter style={{ backgroundColor: "#fff9f5", borderTop: "2px solid #e6691a" }}>
              <Button
                onClick={() => this.answerSave()}
                color={"primary"}
                style={{
                  marginLeft: 15,
                  marginRight: 0,
                  backgroundColor: "#00d4ff",
                  borderColor: "#00d4ff",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: "25px",
                  padding: "8px 20px",
                  fontSize: "0.9rem",
                  boxShadow: "0 0 15px rgba(0, 212, 255, 0.6)",
                  textShadow: "0 0 5px rgba(255, 255, 255, 0.8)",
                  border: "2px solid #00d4ff",
                  transition: "all 0.3s ease"
                }}
              >
                {t("kaydet")}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
}

export const signOut = () => {
    try {
        const existingScript = document.getElementById("chatbot-script");
        if (existingScript) existingScript.remove();

        const possibleIds = [
            "bb-chatbot-widget",
            "bb-chatbot-root",
            "bb-chatbot-container",
        ];
        possibleIds.forEach((id) => {
            const el = document.getElementById(id);
            if (el) el.remove();
        });

        if (window.initBBChatbotWidget) {
            delete window.initBBChatbotWidget;
        }

        localStorage.removeItem("token");
        localStorage.removeItem("loginUser");
        localStorage.clear();

        metrics.redirectURL = undefined;
        if (props?.history) {
            props.history.push("/login");
        } else {
            window.location.href = "#/login";
        } 
        }catch (error) { }
};

function mapStateToProps(state) {
  return {
    loginuser: state.loginReducer,
    menus: state.menuReducer,
    ownsurvey: state.surveyReducer,
    loading: {
      isLoading: state.loadingReducer,
    },
    popupmessage: state.popupMessageReducer,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      clearLoginUser: bindActionCreators(
        loginUserActions.clearLoginUser,
        dispatch
      ),
      getAllTaskInPool: bindActionCreators(poolActions.getPoolCount, dispatch),
      getSurveys: bindActionCreators(surveysActions.getAllSurveys, dispatch),
      isLoading: bindActionCreators(loadingActions.setLoading, dispatch),
      getPopupMessage: bindActionCreators(
        mainActions.getPopupMessage,
        dispatch
      ),
    },
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLayout)
);
